import { render } from "./Paises.vue?vue&type=template&id=9131c416&scoped=true"
import script from "./Paises.vue?vue&type=script&lang=js"
export * from "./Paises.vue?vue&type=script&lang=js"

import "./Paises.vue?vue&type=style&index=0&id=9131c416&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9131c416"]])

export default __exports__